module.exports = __webpack_public_path__ + "img/fontawesome-webfont.ttf?b06871f281fee6b241d60582ae9369b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 597
// module chunks = 0